import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { CombinedSelect, GridSelect } from '@ynap/select';
import BEMHelper from '@ynap/bem-helper';
import { Notification } from '@ynap/notification';

const bem = new BEMHelper('SizeSelect');

class SizeSelect extends PureComponent {
    constructor(props) {
        super(props);
        this.onChangeSelectedSku = this.onChangeSelectedSku.bind(this);
        this.state = {
            isSizeSelected: false,
        };
    }

    onChangeSelectedSku(sizeLabel) {
        if (sizeLabel) this.setState({ isSizeSelected: true });

        const { skus, changeSelectedSku } = this.props;
        const sizeSku = skus.find((sku) => sku.size.labelSize === sizeLabel);
        changeSelectedSku(sizeSku, sizeLabel);
    }

    render() {
        const {
            value,
            price,
            messages,
            className,
            skus,
            customValue,
            onChange,
            loading = false,
            promptError,
            displayLabel = true,
            onDropdown = () => {},
            numberOfDisplaySize,
            sizeGridFeatureToggle,
            disabledControls,
            noSizeNotification,
            hasMeaningfulSize,
            sizeSelectRef,
            disableOneSizeLeft
        } = this.props;

        const { isSizeSelected } = this.state;

        if (loading) {
            return <div className={bem(null, 'loading', className)} />;
        }

        const sizes =
            skus &&
            skus
                .filter((sku) => sku.size)
                .map((sku) => {
                    const { badges = [], buyable, size, soldOutOnline, availability, partNumber } = sku;

                    const stockBadge = badges.find((badge) => badge.type === 'STOCK');

                    const { labelSize = '', centralSizeLabel } = size;

                    const badgeLabel = stockBadge && stockBadge.label ? ` (${stockBadge.label})` : '';
                    const onlyOneLeft = stockBadge?.key === 'BADGE_ONLY_ONE_LEFT';
                    const descriptiveLabel = `${centralSizeLabel || labelSize}${badgeLabel.toLowerCase()}`;
                    const label = centralSizeLabel || labelSize;

                    const skuMetaData = {
                        partNumber,
                        price: price?.finalPriceWithoutCurrencySymbol,
                        currency: price?.currency?.label,
                        availability,
                    };

                    return {
                        value: customValue ? sku[customValue] : labelSize,
                        key: size.labelSize,
                        unavailable: !buyable || soldOutOnline,
                        label: sizeGridFeatureToggle ? label : descriptiveLabel,
                        descriptiveLabel,
                        badgeLabel,
                        onlyOneLeft,
                        labelSize,
                        skuMetaData,
                    };
                });

        const multipleSizes = sizes && sizes.length > 1 ? 'multipleSizes' : '';
        const availableSizes = sizes?.filter((size) => size.unavailable === undefined);
        const oneSizeLeft = !disableOneSizeLeft && availableSizes?.length === 1 ? availableSizes[0].value : undefined;

        const selectProps = {
            value,
            partNumber: availableSizes[0]?.skuMetaData?.partNumber,
            onChange: onChange ? onChange : this.onChangeSelectedSku,
            options: sizes,
            promptError: !isSizeSelected && promptError
        };

        return (
            <div className={bem('size', null, `${className} ${multipleSizes}`)} ref={sizeSelectRef}>
                {sizes && sizes.length > 1 ? (
                    <>
                        {displayLabel && <label className={bem('label')}>{messages.sizes.initialValue()}</label>}
                        {sizeGridFeatureToggle ? (
                            <GridSelect
                                {...selectProps}
                                oneSizeLeft={oneSizeLeft}
                                name="sizeSelect" // this means can only have one SizeSelect on the page at a time
                            />
                        ) : (
                            <CombinedSelect
                                {...selectProps}
                                emptyLabel={messages.sizes.initialValue()}
                                numOfListElementsDisplayed={numberOfDisplaySize ? numberOfDisplaySize : undefined}
                                onDropdown={onDropdown}
                                disabled={disabledControls}
                                noSizeNotification={noSizeNotification}
                            />
                        )}
                    </>
                ) : (
                    <>
                        <div className={bem('sizeLabel')}>
                            <span>{messages.sizes.sizeLabel()}</span>
                            <span className={bem('oneSizeLabel')}>
                                {sizes[0] && sizes[0].label && sizes[0].labelSize
                                    ? sizes[0].label
                                    : `${messages.sizes.oneSizeLabel()}${sizes[0]?.badgeLabel ? sizes[0].badgeLabel : ''}`}
                            </span>
                        </div>
                        {hasMeaningfulSize && (
                            <div className={bem('oneSizeLeftStyle')}>
                                <GridSelect {...selectProps} oneSizeLeft={oneSizeLeft} name="sizeSelect" />
                            </div>
                        )}
                    </>
                )}
                {noSizeNotification && !sizeGridFeatureToggle && (
                    <Notification
                        className={bem('buttonNotification') || bem('notification', 'bottom')}
                        arrow="bottom"
                        type="error"
                        message={noSizeNotification}
                    />
                )}
            </div>
        );
    }
}

SizeSelect.propTypes = {
    numberOfDisplaySize: PropTypes.string,
    partNumber: PropTypes.string,
    value: PropTypes.string.isRequired,
    changeSelectedSku: PropTypes.func,
    className: PropTypes.string,
    messages: PropTypes.shape({
        sizes: PropTypes.shape({ sizeLabel: PropTypes.func.isRequired, oneSizeLabel: PropTypes.func.isRequired, initialValue: PropTypes.func.isRequired }),
    }),
    promptError: PropTypes.bool,
    displayLabel: PropTypes.bool,
    customValue: PropTypes.string,
    onChange: PropTypes.func,
    loading: PropTypes.bool,
    onDropdown: PropTypes.func,
    sizeGridFeatureToggle: PropTypes.bool,
};

export default SizeSelect;
